import { call, put, select, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { doFilter, setAttribute, setFiltro, triggerLoadData, triggerTrocaFiltro } from "./ClientesSlice";
import { formatDateSemHoras, validaCPF } from "../core/helpers"
import { server_url } from "../core/config_geral";

function* doLoadData() {
    yield call(() => console.log("Loading data"))

    yield put(setAttribute({
        campo: "loading",
        valor: true
    }))
    var token = yield select((state) => state.auth.token)

    // var r = yield call(() => axios.get("https://api.anano.com.br/storage/buckets/anano.data.ui/arquivos/a00e3f3e-3ced-4d31-afc1-d17c667006c3", {
    //     headers: {
    //         'Authorization': 'Bearer ' + token
    //     }
    // }))

    // yield put(setAttribute({
    //     campo: "ultimaAlteracao",
    //     valor: r.data['dataUltimaAlteracao']
    // }))

    // var r = yield call(() => axios.get("https://api.anano.com.br/storage/dw/buckets/anano.data.ui/arquivos/365dc2f8-d607-4914-b893-16f263c5fa91/download?no_link=true&access_token=" + token
    // ).then(response => response)
    //     .catch(error => error))

        var payload = {
            "action" : "REL_DOWNLOAD_RELATORIO",
            "runNow" : true,
            "payload" : JSON.stringify({
                "codigo" : "REL_ANANO_DATA_GERENCIAMENTO_CLIENTE",
                "tenantId" : "ae88fa77-75ac-4f2c-98ac-1d732fcbe07c",
                "versao" : "latest"
            })
        }
    
        var formData = new FormData()
        // formData.append("file",
        //     new Blob([JSON.stringify("")], {
        //         type: "application/json"
        //     }))
        formData.append("data",
            new Blob([JSON.stringify(payload)], {
                type: "application/json"
            }))
    
        var r = yield call(() => axios.post(server_url + "/rpc", formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + token
            }
        }).then(response => response)
            .catch(error => error))

            yield put(setAttribute({
                campo: "ultimaAlteracao",
                valor: formatDateSemHoras(r.data.data)
            }))

            console.log(r.data)

    var data = r.data.dados
    var dataToPrint = []

    data = data.sort((a, b) => a.retornoMensal > b.retornoMensal ? -1 : 1)

    var n = 0
    var totalMensal = 0
    var totalSemConsumidor = 0


    data.forEach(e => {
        totalMensal += e.retornoMensal
        if (e.cod != 1)
            totalSemConsumidor += e.retornoMensal
    })

    var somadoAteAqui = 0
    var somadoAteAquiLimpo = 0
    data.forEach(e => {
        somadoAteAqui += e.retornoMensal
        if (somadoAteAqui / totalMensal < 0.8) e.curva = "A"
        else if (somadoAteAqui / totalMensal < 0.95) e.curva = "B"
        else if (e.vendasPorMes > 0) e.curva = "C"
        else e.curva = "D"

        if (e.cod == 1) {
            e.curvaLimpa = "-"
        } else {
            somadoAteAquiLimpo += e.retornoMensal
            if (somadoAteAquiLimpo / totalSemConsumidor < 0.8) e.curvaLimpa = "A"
            else if (somadoAteAquiLimpo / totalSemConsumidor < 0.95) e.curvaLimpa = "B"
            else if (e.vendasPorMes > 0) e.curvaLimpa = "C"
            else e.curvaLimpa = "D"
        }

    })

    data
        .filter(e => e.diasUltimaVenda > 0)
        .forEach(e => {
            n++

            var t = {
                "index": n,
                "cod": e.cod,
                "retornoMensal": "R$ " + (e.retornoMensal).toFixed(2),
                "retornoMensalCru": e.retornoMensal,
                "nome": e.nome,
                "pf": validaCPF(e.cpf),
                "curva": e.curvaLimpa + e.curva,
                "diasUltimaVenda": e.diasUltimaVenda,
                "vendasPorMes": e.vendasPorMes,
                "frequencia": "-",
                "freqColor": "-",
                "freqTextColor" : "#000",
                "novo" : "-",
                "novoColor" : "-",
                "diasDataCadastro" : e.diasDataCadastro,
                "recencia" : "-",
                "recenciaColor" : "-",
                "recenciaTextColor" : "#000",
                "diasParaUmaVenda" : "0"

            }

            if (e.vendasPorMes >= 2) {
                t.frequencia = "Quinzenal"
                t.freqColor = "rgb(73, 100, 239)"
            } else if (e.vendasPorMes >= 1) {
                t.frequencia = "Mensal"
                t.freqColor = "green"
            } else if (e.vendasPorMes >= 0.5) {
                t.frequencia = "Bimestral"
                t.freqColor = "rgb(194, 172, 0)"
            } else if (e.vendasPorMes >= 0.33) {
                t.frequencia = "Trimestral"
                t.freqColor = "rgb(194, 0, 0)"
            } else {
                t.frequencia = "Sem freq."
                t.freqColor = "rgb(123, 9, 9)"
                t.freqTextColor = "#fff"
            }

            if(e.diasDataCadastro < 30) {
                t.novo = "Super novo"
                t.novoColor = "green"
            } else if(e.diasDataCadastro < 180) {
                t.novo = "Novo"
                t.novoColor = "#CDCDCD"
            } else {
                t.novo = false
            }

            var diasParaUmaVenda = 30 / e.vendasPorMes
            diasParaUmaVenda = Math.ceil(diasParaUmaVenda)
            if(diasParaUmaVenda < 1) diasParaUmaVenda = 1

            t.diasParaUmaVenda = diasParaUmaVenda

            if(e.vendas180dias <= 1) {
                t.recencia = "Só fez uma compra até agora"
                t.recenciaColor = "#CDCDCD"
            } else if(e.diasUltimaVenda < Math.ceil(0.8 * diasParaUmaVenda)) {
                t.recencia = "OK"
                t.recenciaColor = "rgb(73, 100, 239)"
            } else if(e.diasUltimaVenda < Math.ceil(0.9 * diasParaUmaVenda)) {
                t.recencia = "Acelerar"
                t.recenciaColor = "green"
            } else if (e.diasUltimaVenda < Math.ceil(1.1 * diasParaUmaVenda)) {
                t.recencia = "Manter"
                t.recenciaColor = "rgb(194, 172, 0)"
            } else if (e.diasUltimaVenda < Math.ceil(1.3 * diasParaUmaVenda)) {
                t.recencia = "Diminuindo"
                t.recenciaColor = "rgb(245 113 39)"
            } else if (e.diasUltimaVenda < Math.ceil(1.6 * diasParaUmaVenda)) {
                t.recencia = "Perdendo"
                t.recenciaColor = "rgb(123, 9, 9)"
                t.recenciaTextColor = "#fff"
            } else if (e.diasUltimaVenda < Math.ceil(2.5 * diasParaUmaVenda)) {
                t.recencia = "Recuperar"
                t.recenciaColor = "rgb(194, 0, 0)"
                t.recenciaTextColor = "#fff"
            } else {
                t.recencia = "Perdido"
                t.recenciaColor = "#131313"
                t.recenciaTextColor = "#fff"
            }

            dataToPrint.push(t)
        })

    var faturamento = {
        medioMensal: totalMensal,
        medioMensalSemConsumidor: totalSemConsumidor,
        curva: {
            a: {
                total: 0,
                clientes: 0
            },
            b: {
                total: 0,
                clientes: 0
            },
            c: {
                total: 0,
                clientes: 0
            },
            d: {
                total: 0,
                clientes: 0
            },
        },
        pf: {
            total: 0,
            clientes: 0,
            media: 0
        },
        pj: {
            total: 0,
            clientes: 0,
            media: 0
        }
    }

    var totalClientesPFComVenda = 0
    var totalFaturamentoPF = 0
    var totalClientesPJComVenda = 0
    var totalFaturamentoPJ = 0

    dataToPrint.forEach(e => {

        if (e.cod != 1) {
            var tag = e.curva.startsWith("A") ? "a" : e.curva.startsWith("B") ? "b" : e.curva.startsWith("C") ? "c" : "d"
            faturamento.curva[tag].total += e.retornoMensalCru
            faturamento.curva[tag].clientes += 1

            if (e.cod != 1) {
                if (e.retornoMensalCru > 0) {
                    if (e.pf) {
                        totalClientesPFComVenda += 1
                        totalFaturamentoPF += e.retornoMensalCru
                    } else {
                        totalClientesPJComVenda += 1
                        totalFaturamentoPJ += e.retornoMensalCru
                    }
                }
            }
        }
    })

    faturamento.pf.total = totalFaturamentoPF
    faturamento.pf.clientes = totalClientesPFComVenda
    faturamento.pf.media = totalFaturamentoPF / totalClientesPFComVenda
    faturamento.pj.total = totalFaturamentoPJ
    faturamento.pj.clientes = totalClientesPJComVenda
    faturamento.pj.media = totalFaturamentoPJ / totalClientesPJComVenda

    console.log(totalMensal)
    console.log(totalSemConsumidor)
    console.log(data)


    yield put(setAttribute({
        campo: "loading",
        valor: false
    }))

    yield put(setAttribute({
        campo: "data",
        valor: dataToPrint
    }))

    yield put(doFilter())

    yield put(setAttribute({
        campo: "faturamento",
        valor: faturamento
    }))
}

function* doTriggerTrocaFiltro(action) {
    yield put(setFiltro(action.payload))
    yield put(doFilter())
} 


export function* listenTriggerLoadData() {
    yield takeEvery(triggerLoadData, doLoadData);
}

export function* listenTriggerTrocaFiltro() {
    yield takeEvery(triggerTrocaFiltro, doTriggerTrocaFiltro);
}
